import React from 'react';
import AdCard from './AdCard';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

const AdList = ({ ads, loading, hasFetched, loadingMore }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      direction: 'rtl',
      py: { xs: 1, sm: 2 },
      px: { xs: 1, sm: 2 },
      justifyContent: { xs: 'center', md: 'flex-start' },
      columnGap: { xs: 0, sm: 0, md: '24px' },
    }}
  >
    {ads.length === 0 && hasFetched && !loading ? (
      <Box sx={{ width: '100%' }}>
        <div style={{ textAlign: 'center', color: '#888', fontSize: '1.25rem', padding: '3rem 0' }}>
          هیچ آگهی‌ای پیدا نشد.
        </div>
      </Box>
    ) : (
      ads.map((ad) => (
        <Box
          key={ad.id}
          sx={{
            flex: { xs: '0 0 100%', sm: '0 0 50%', md: '0 0 calc((100% - 72px) / 4)' },
            maxWidth: { xs: '90vw', sm: '50%', md: 'calc((100% - 72px) / 4)' },
            mx: { xs: 'auto', sm: 0, md: 0 },
            mb: { xs: 1.5, sm: 2, md: 3 },
            position: 'relative',
          }}
        >
          <AdCard ad={ad} />
        </Box>
      ))
    )}
    {loadingMore && (
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={32} />
      </Box>
    )}
  </Box>
);

export default AdList;
